module.exports = __webpack_public_path__ + "static/16-7a676c007fc6c9bab360a3805dd1cf29.jpg";